import ApplyLeaveAdminActionType from './ApplyLeaveAdmin.types';
import { decodeHexResponse } from '../_common/common.utils';

const INITIAL_STATE: any = {
	applyLeaveAdminResponse: null,
	allEmployeesAdminResponse: null,
};

const applyLeaveAdminReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_START:
			return { ...state, applyLeaveAdminResponse: null };
		case ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_SUCCESS:
			return {
				...state,
				applyLeaveAdminResponse: decodeHexResponse(
					action.payload,
					ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_KEY,
				),
			};
		case ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_FAILURE:
			return {
				...state,
				applyLeaveAdminResponse: decodeHexResponse(
					action.payload,
					ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_KEY,
				),
			};
		case ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_RESPONSE_CHANGED:
			return { ...state, applyLeaveAdminResponse: null };
		case ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_RESPONSE_REST_START:
			return { ...state, applyLeaveAdminResponse: null };
		case ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_START:
			return { ...state, allEmployeesAdminResponse: null };
		case ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_SUCCESS:
			return {
				...state,
				allEmployeesAdminResponse: decodeHexResponse(
					action.payload,
					ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_KEY,
				),
			};
		case ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_FAILURE:
			return {
				...state,
				allEmployeesAdminResponse: decodeHexResponse(
					action.payload,
					ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_KEY,
				),
			};
		case ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_RESPONSE_CHANGED:
			return { ...state, allEmployeesAdminResponse: null };
		case ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_RESPONSE_REST_START:
			return { ...state, allEmployeesAdminResponse: null };
		default:
			return state;
	}
};

export default applyLeaveAdminReducer;
